import script from "./BaseCalculator.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseCalculator.vue?vue&type=script&lang=ts&setup=true"

import "./BaseCalculator.vue?vue&type=style&index=0&id=149ad192&lang=scss"

const __exports__ = script;

export default __exports__